module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ryd2A/tc-custom/FC-9781528958028.jpg?1688985072568?1705688333516",
      "alt": "This image is the cover for the book Six Miles from Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Six Miles from Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Six Miles from Home chronicles the compelling events of one of the UK's worst urban air disasters that claimed the lives of 72 passengers and crew. Drawing on 20 years of meticulous research and extensive interviews with all those involved, the author has produced a truly remarkable and compelling book. Full of suspense and high drama, it tells a powerful account of death and survival, with compassion and understanding that leaves the reader with lasting images. As an analysis of the disaster and how it changed lives forever, this account is an important social record."), _c('br'), _vm._v("The book is the achievement of a skilful writer who is passionate about his subject. This is the author's fourth book on civilian aviation accidents; in addition, he has contributed numerous articles on the subject for newspapers and magazines. He has also taken part in a number of television documentaries. Based in Cheshire, his previous books include, The Munich Air Disaster, which deals with the Manchester United tragedy; and The Devil Casts His Net, which chronicles the events surrounding the Winter Hill air disaster.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Morrin\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0